export enum PhotoViews {
  ViewOnly,
  Full
}
